import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import { Button } from '../General/Button';
import { ErrorAlert } from '../../Defaults/Alerts/ErrorAlert';
import { Input } from '../General/Input';
import { emailIsValid } from '../../../utilities';
import { Loader } from '../General/Loader';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { SuccessAlert } from '../../Defaults/Alerts/SuccessAlert';
import { InfoText, InfoType } from '../General/InfoText';
import { FormInput, FormWrapper } from '../Form/FormInput';
import { LoginButton, Header, Form, Wrapper } from '../General/Auth';
import {
  FlexRowCenterVertical,
  FlexColCenterVertical,
  FlexRow,
} from '../../..';
import { B2CRegisterFromFields } from './types';
import { Recoverable } from 'repl';
import { Select } from '../../Zemplin/General/Select';
import { CheckBox } from '../General/Checkbox';

interface Props {
  cartId: string | undefined;
  handleFormSubmit: any;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
}

function RegisterForm({
  cartId,
  handleFormSubmit,
  isFetching,
  successMessage,
  errorMessage,
}: Props) {
  const SLOVAKIA = { value: 'sk', name: 'Slovensko' };

  const COUNTRIES: Array<{ value: string; name: string }> = [SLOVAKIA];

  const [fields, setFields] = React.useState<B2CRegisterFromFields>({
    gdprAccept: false,
    newsletterAccept: false,
    name: '',
    surname: '',
    email: '',
    phone: '',
    password: '',
    password_again: '',
    billing_address: {
      name: '',
      surname: '',
      street: '',
      number: '',
      city: '',
      zip: '',
      country: SLOVAKIA,
    },
  });

  const setBasicField = (name: string, e: any): void => {
    setFields({ ...fields, [name]: e.target.value });
  };

  const toggleField = (name: string): void => {
    setFields({ ...fields, [name]: !fields[name] });
  };

  const handleForm = e => {
    e.preventDefault();
    handleFormSubmit(fields);
  };

  const setBillingAddresField = (name: string, e: any): void => {
    setFields({
      ...fields,
      billing_address: { ...fields.billing_address, [name]: e.target.value },
    });
  };

  const validFields = (fieldsAll: B2CRegisterFromFields) => {
    if (!fieldsAll.gdprAccept || !fields.gdprAccept) {
      return false;
    }

    if (
      !fieldsAll.email ||
      !fieldsAll.name ||
      !fieldsAll.password ||
      !fieldsAll.password_again ||
      !fieldsAll.phone ||
      !fieldsAll.surname
    ) {
      return false;
    }

    if (
      !fieldsAll.billing_address.city ||
      !fieldsAll.billing_address.country ||
      !fieldsAll.billing_address.name ||
      !fieldsAll.billing_address.number ||
      !fieldsAll.billing_address.street ||
      !fieldsAll.billing_address.surname ||
      !fieldsAll.billing_address.zip
    ) {
      return false;
    }
    return true;
  };

  // if (successMessage) {
  //   return (
  //     <Wrapper>
  //       <div>{successMessage && <SuccessAlert message={successMessage} />}</div>
  //     </Wrapper>
  //   );
  // }

  return (
    <StyledWrapper>
      <Header>{`${__('Vytvoriť účet')}?`}</Header>
      <div>
        {errorMessage && (
          <>
            <ErrorAlert message={errorMessage} />
            <br />
            <br />
          </>
        )}
      </div>
      {successMessage && (
        <InfoText type={InfoType.SUCCESS} info={successMessage} />
      )}
      <Form onSubmit={handleForm}>
        <SubTitle>{`${__('Kontaktné údaje')}`}</SubTitle>
        <RowInput>
          <FormInput
            type="text"
            name={'name'}
            label={__('Meno')}
            value={fields.name}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('name', e)}
            required={true}
          />
          <FormInput
            type="text"
            value={fields.surname}
            name={'surname'}
            label={__('Priezvisko')}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('surname', e)}
            minWidthPx={320}
            marginBottom={0}
            required={true}
          />
        </RowInput>
        <RowInput>
          <FormInput
            type="text"
            label={__('Tel. číslo')}
            value={fields.phone}
            placeholder={__('Napíšte v tvare +421915555666')}
            name={'phone'}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('phone', e)}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            required={true}
          />
          <FormInput
            type="text"
            value={fields.email}
            name={'email'}
            label={__('Email')}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('email', e)}
            marginBottom={0}
            required={true}
          />
        </RowInput>
        <RowInput>
          <FormInput
            type="password"
            value={fields.password}
            name="password"
            label={__('Heslo')}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('password', e)}
            marginRight={32}
            minWidthPx={320}
            marginBottom={0}
            required={true}
          />
          <FormInput
            type="password"
            value={fields.password_again}
            name="confirmPassword"
            label={__('Potvrdenie hesla')}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBasicField('password_again', e)}
            marginBottom={0}
            minWidthPx={320}
            required={true}
          />
        </RowInput>
        <SubTitle>{`${__('Fakturačná adresa')}`}</SubTitle>
        <RowInput>
          <FormInput
            type="text"
            name={'billingName'}
            label={__('Meno')}
            required={true}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBillingAddresField('name', e)}
            value={fields.billing_address.name}
          />
          <FormInput
            type="text"
            name={'billingSurname'}
            required={true}
            label={__('Priezvisko')}
            marginBottom={0}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setBillingAddresField('surname', e)}
            value={fields.billing_address.surname}
          />
        </RowInput>
        <AddressWrapper>
          <FormWrapper noWrap={true} marginRight={32}>
            <FormInput
              name="street"
              type="text"
              label={__('Ulica')}
              required={true}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              marginBottom={0}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setBillingAddresField('street', e)}
              value={fields.billing_address.street}
            />
            <FormInput
              name="street_number"
              type="text"
              label={__('Číslo')}
              required={true}
              maxWidth={34}
              maxWidthPx={80}
              marginBottom={0}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setBillingAddresField('number', e)}
              value={fields.billing_address.number}
            />
          </FormWrapper>
          <FormWrapper noWrap={true}>
            <FormInput
              name="city"
              type="text"
              label={__('Mesto')}
              required={true}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              marginBottom={0}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setBillingAddresField('city', e)}
              value={fields.billing_address.city}
            />
            <FormInput
              name="zip"
              type="text"
              label={__('PSČ')}
              required={true}
              maxWidth={34}
              maxWidthPx={80}
              marginBottom={0}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setBillingAddresField('zip', e)}
              value={fields.billing_address.zip}
            />
          </FormWrapper>{' '}
        </AddressWrapper>

        <Select
          marginBottom={16}
          name="country"
          label={__('Krajina')}
          value={fields.billing_address.country.value}
          options={COUNTRIES}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setBillingAddresField('country', e)}
        />

        <CheckBox
          name={'gdprAgree'}
          type={'checkbox'}
          selected={fields.gdprAccept}
          required={true}
          label={
            <>
              {__('Súhlasím s')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={'obchodne-podmienky'}
              >
                {__('obchodnými podmienkami')}
              </a>
              {__(' a oboznámil som sa so')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={
                  'https://www.appgdpr.sk/doc/01HQR-J55AH-1XYK-2TZE-ZTZP-8WT3/DIP'
                }
              >
                {__('Zásadami ochrany OÚ')}
              </a>
            </>
          }
          wrapperStyle={{ marginTop: rem(32) }}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={e => toggleField('gdprAccept')}
        />
        <CheckBox
          name={'newsletterAgree'}
          type={'checkbox'}
          selected={fields.newsletterAccept}
          label={
            <>
              {__('Súhlasím so zasielaním newslettra')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={
                  'https://www.appgdpr.sk/doc/01HQR-HZY7T-JEEH-94V1-71NP-8HXP/DIP%20Vyhl%c3%a1senie%20o%20ochrane%20s%c3%bakromia%20-%20In%c3%a9%20%5Bodberatelia%20newslettra%5D.html'
                }
              >
                ({__('podmienky súhlasu')})
              </a>
            </>
          }
          wrapperStyle={{ marginTop: rem(16) }}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={e => toggleField('newsletterAccept')}
        />

        <StyledLoginButton
          disabled={isFetching || !validFields(fields)}
          type="submit"
        >
          {isFetching ? (
            <FlexRowCenter>
              {`${__('Registrujem')}...`}
              <Loader className="marginLeft" small={true} />
            </FlexRowCenter>
          ) : (
            __('Registrovať sa')
          )}
        </StyledLoginButton>
      </Form>
      <LoginWrapper>
        {`${__('Máte svoj účet')}? `}
        <Link to={__r('routes:prihlasenie', '/prihlasenie')}>
          <Login>{__('Prihláste sa')}</Login>
        </Link>
      </LoginWrapper>
    </StyledWrapper>
  );
}

const StyledLoginButton = styled(LoginButton)`
  max-width: ${rem(670)};
  margin-bottom: 0;
`;

const StyledWrapper = styled(Wrapper)`
  max-width: ${rem(702)};
`;

const SubTitle = styled.h2`
  font-size: ${rem(30)};
  font-weight: 400;
  margin-top: ${rem(56)};
`;

const AddressWrapper = styled(FlexRowCenterVertical)`
  flex-flow: row wrap;
`;

const secondaryText = css`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration-color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

export const RowInput = styled(FlexRow)<{
  maxWidth?: number;
  marginBottom: number;
}>`
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
  ${({ theme }) => theme.mediab.m760`
        flex-direction: column;
    `}
`;

const Login = styled.p`
  ${secondaryText};
  display: inline-block;
  text-decoration: underline;
  margin: 0;
  margin-left: ${rem(4)};
`;

const LoginWrapper = styled.span`
  ${secondaryText};
  display: flex;
  justify-content: center;
  margin-top: ${rem(16)};
`;

export { RegisterForm };
